import React from 'react';
import { Link } from 'react-router-dom';

import Shape from '../../images/register-shape.svg'

const RegisterSection = () => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <section className="register-section">
            <div className="container">
                <div className="content centered">
                    <div className="text">
                        <span>Get Involved</span>
                        <h2>Join Our Community - Register as a Volunteer</h2>
                        <Link onClick={ClickHandler} to="/contact" className="theme-btn">Contact Now <i className="flaticon-right-arrow-1"></i></Link>
                    </div>
                </div>
            </div>
            <div className="shape">
                <img src={Shape} alt="" />
            </div>
        </section>
    );
};

export default RegisterSection;
